// src/components/AppointmentList/AppointmentList.jsx
import React, { useState, useEffect, useMemo, useCallback ,useRef } from 'react';
import axios from 'axios';
import { useTable, usePagination, useSortBy, useGlobalFilter, useFilters } from 'react-table';
import AdminSidebar from '../Adminsidebar/AdminSidebar'; // Adjust path
import './Appoint.css'; // Your updated CSS file
import * as XLSX from 'xlsx'; // Import xlsx library
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AppointmentReceipt from './AppointmentReceipt';
// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.hitkarihospital.com:5005';

// Global Filter (Search) Component - Remains the same
const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
    return (
        <div className="appoint-global-filter-container mb-3">
            <input
                value={globalFilter || ""}
                onChange={e => setGlobalFilter(e.target.value || undefined)}
                placeholder="Search all columns..."
                className="form-control appoint-search-input"
            />
        </div>
    );
};

// Dropdown Filter for Status Columns - Remains the same
function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  const options = useMemo(() => {
    const optionsSet = new Set();
    preFilteredRows.forEach(row => {
      optionsSet.add(row.values[id]);
    });
    // Add 'All' and sort, ensuring 'All' is first
    const sortedOptions = Array.from(optionsSet).sort();
    return ['All', ...sortedOptions.filter(opt => opt !== undefined && opt !== null)];
  }, [id, preFilteredRows]);

  return (
    <select
      className="form-control form-control-sm appoint-column-filter"
      value={filterValue || 'All'}
      onChange={e => {
        setFilter(e.target.value === 'All' ? undefined : e.target.value);
      }}
    >
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option === 'All' ? 'All Statuses' : option?.toString().replace(/_/g, ' ').toUpperCase()}
        </option>
      ))}
    </select>
  );
}


function AppointmentList() {
    const [appointmentsData, setAppointmentsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
   const [activeStatusFilter, setActiveStatusFilter] = useState('confirmed');
    const [receiptDataForDownload, setReceiptDataForDownload] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const receiptComponentRef = useRef(null);
  const [dayFilter, setDayFilter] = useState('all');
    // NEW: State for Excel export doctor filter
    const [uniqueDoctorNames, setUniqueDoctorNames] = useState([]);
    const [selectedDoctorForExport, setSelectedDoctorForExport] = useState(''); // Empty string means 'All Doctors'
  const [receiptDataForPrint, setReceiptDataForPrint] = useState(null);
    const [isPrinting, setIsPrinting] = useState(false);
  
    // Fetching Logic
    const fetchAppointments = useCallback(async (statusFilter = 'All') => {
    setLoading(true);
    setError("");
    let url = `${API_BASE_URL}/api/appointments`;
    try {
        const response = await axios.get(url);
        if (response.data.success) {
            // ================== CHANGE IS HERE ==================
            // 1. Sort all appointments by creation date (oldest first)
            const sortedAppointments = response.data.appointments.sort((a, b) => 
                new Date(a.createdAt) - new Date(b.createdAt)
            );

            // 2. Add a sequential ID to each appointment object
            const appointmentsWithSeqId = sortedAppointments.map((appointment, index) => ({
                ...appointment,
                sequentialId: index + 1, // Add 1 to start counting from 1
            }));

            setAppointmentsData(appointmentsWithSeqId);
            // ====================================================
        } else {
            setError(response.data.message || "Failed to fetch appointments.");
        }
    } catch (err) {
        setError("An error occurred while fetching appointments.");
        console.error("Error fetching appointments:", err);
    } finally {
        setLoading(false);
    }
}, [API_BASE_URL]);

    useEffect(() => {
        fetchAppointments(activeStatusFilter);
    }, [fetchAppointments, activeStatusFilter]);

    // NEW: Populate unique doctor names for export filter
    useEffect(() => {
        if (appointmentsData.length > 0) {
            const doctors = new Set(appointmentsData.map(app => app.doctorName).filter(name => name));
            setUniqueDoctorNames(['All Doctors', ...Array.from(doctors).sort()]);
        } else {
            setUniqueDoctorNames(['All Doctors']);
        }
    }, [appointmentsData]);
 const handleDownloadReceipt = (appointmentDetails) => {
        if (isDownloading) return; // Prevent multiple clicks while one is processing
        setIsDownloading(true);
        // Set the data, which will cause the hidden receipt component to render
        setReceiptDataForDownload(appointmentDetails);
    };
 // NEW: useEffect to generate and download the PDF after the component has rendered
    useEffect(() => {
        if (receiptDataForDownload && receiptComponentRef.current) {
            const receiptElement = receiptComponentRef.current;
            
            html2canvas(receiptElement, { scale: 2, useCORS: true })
            .then(canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                
                const isSuccess = receiptDataForDownload.status === 'confirmed' || receiptDataForDownload.paymentStatus === 'paid';
                const status = isSuccess ? 'Success' : 'Failed';
              const numericId = (parseInt(receiptDataForDownload._id.slice(-7), 16) % 900000) + 100000;
const fileName = `Appointment_Receipt_${status}_${numericId}.pdf`;
                
                pdf.save(fileName);
            })
            .catch(err => {
                console.error("Error generating PDF:", err);
                alert("Could not generate the receipt PDF. Please try again.");
            })
            .finally(() => {
                // Reset state to hide the component and re-enable buttons
                setReceiptDataForDownload(null);
                setIsDownloading(false);
            });
        }
    }, [receiptDataForDownload]);

     const handlePrintReceipt = (appointmentDetails) => {
        if (isPrinting) return;
        setIsPrinting(true);
        setReceiptDataForPrint(appointmentDetails);
    };

    useEffect(() => {
        if (receiptDataForPrint && receiptComponentRef.current) {
            // --- START: THE NEW AND IMPROVED PRINT LOGIC ---

            // 1. Define all the necessary CSS styles as a string.
            // This is the entire content of your AppointmentReceipt.css file.
            const printStyles = `
                .receipt-pdf-wrapper {
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                    width: 210mm;
                    min-height: 297mm;
                    padding: 30px;
                    background-color: #fff;
                    color: #333;
                    box-sizing: border-box;
                }
                .receipt-pdf-header {
                    display: flex; align-items: center; border-bottom: 2px solid #333;
                    padding-bottom: 15px; margin-bottom: 25px;
                }
                .receipt-pdf-logo { max-height: 60px; margin-right: 20px; }
                .receipt-pdf-header-text h2 { margin: 0; font-size: 28px; font-weight: 600; }
                .receipt-pdf-header-text p { margin: 5px 0 0; font-size: 16px; color: #666; }
                .receipt-pdf-status-banner {
                    padding: 15px 20px; margin-bottom: 25px; border-radius: 8px; text-align: center;
                    color: #fff; display: flex; align-items: center; justify-content: center;
                }
                .receipt-pdf-wrapper.success .receipt-pdf-status-banner { background-color: #28a745; }
                .receipt-pdf-wrapper.failed .receipt-pdf-status-banner { background-color: #dc3545; }
                .receipt-pdf-status-icon { font-size: 24px; margin-right: 15px; }
                .receipt-pdf-status-title { margin: 0; font-size: 22px; font-weight: 500; }
                .receipt-pdf-body { padding: 0 10px; }
                .receipt-pdf-greeting { font-size: 16px; margin-bottom: 30px; line-height: 1.6; }
                .receipt-pdf-section { margin-bottom: 30px; }
                .receipt-pdf-section h4 {
                    font-size: 18px; font-weight: 600; color: #0056b3; margin-bottom: 15px;
                    padding-bottom: 8px; border-bottom: 1px solid #e0e0e0;
                }
                .receipt-pdf-grid {
                    display: grid; grid-template-columns: 180px 1fr;
                    gap: 12px 20px; font-size: 15px;
                }
                .receipt-pdf-grid span { color: #555; }
                .receipt-pdf-grid strong { font-weight: 500; }
                .receipt-pdf-code {
                    font-family: 'Courier New', Courier, monospace; background-color: #f0f0f0;
                    padding: 3px 6px; border-radius: 4px; font-size: 14px;
                }
                .status-text-confirmed, .status-text-paid { color: #28a745; font-weight: bold; }
                .status-text-failed, .status-text-cancelled { color: #dc3545; font-weight: bold; }
                .status-text-pending_payment { color: #ffc107; font-weight: bold; }
                .receipt-pdf-footer {
                    margin-top: 40px; padding-top: 20px; border-top: 2px solid #333;
                    text-align: center; color: #777; font-size: 12px;
                }
                .receipt-pdf-round-logo { margin-top: 15px; max-height: 70px; }
                @media print {
                    @page {
                        size: A4;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                    }
                    .receipt-pdf-wrapper {
                        box-shadow: none;
                        border: none;
                    }
                }
            `;

            // 2. Link to the Font Awesome CDN for the icons.
            const fontAwesomeCDN = '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">';

            // 3. The robust printing logic.
            let printWindow = null;
            try {
                const printContents = receiptComponentRef.current.innerHTML;

                printWindow = window.open('', '_blank');
                if (!printWindow) {
                    alert("Pop-up blocked! Please allow pop-ups for this site to print.");
                    throw new Error("Popup blocked");
                }
                
                // Write the complete HTML structure, including the head with styles and icons.
                printWindow.document.write(`
                    <html>
                        <head>
                            <title>Appointment Receipt - ${receiptDataForPrint.appointmentNumber || ''}</title>
                            ${fontAwesomeCDN}
                            <style>${printStyles}</style>
                        </head>
                        <body>
                            ${printContents}
                        </body>
                    </html>
                `);
                printWindow.document.close();
                printWindow.focus();

                // Give the browser a moment to render everything before printing.
                setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                }, 500);

            } catch (error) {
                console.error("Failed to print receipt:", error);
                if (error.message !== "Popup blocked") {
                  alert("An error occurred while trying to print.");
                }
                if (printWindow) printWindow.close();
            } finally {
                // ALWAYS reset the state, even if printing fails.
                setIsPrinting(false);
                setReceiptDataForPrint(null);
            }
            // --- END: THE NEW AND IMPROVED PRINT LOGIC ---
        }
    }, [receiptDataForPrint]);

       const columns = useMemo(
        () => [
         {
              
                Header: 'Appt. ID',
                accessor: 'appointmentNumber', // Use the new field from backend
                Filter: () => null,
                Cell: ({ value }) => <small>{value || 'N/A'}</small>
            },
{
                // === CHANGE 2A: ADD "BOOKED ON" (CREATEDAT) COLUMN ===
                Header: 'Booked On',
                accessor: 'createdAt',
                Filter: () => null,
                Cell: ({ value }) => {
                    if (!value) return 'N/A';
                    const date = new Date(value);
                    return (
                        <div>
                            <div>{date.toLocaleDateString('en-GB')}</div>
                            <small className="text-muted">{date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</small>
                        </div>
                    );
                },
                sortType: 'datetime'
            },
            {
              Header: 'Appointment Date',
              accessor: 'appointmentDate', 
              id: 'appointmentDateTime',
              Filter: () => null,
              Cell: ({ row }) => {
                const dateStr = row.original.appointmentDate;
                const timeStr = row.original.appointmentTime || '';
                if (!dateStr) return <div>N/A</div>;
                const dateObj = new Date(dateStr);
                const formattedDate = dateObj.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
                return (
                  <div>
                    <div>{formattedDate}</div>
                    <small className="text-muted">{timeStr || 'N/A'}</small>
                  </div>
                );
              },
              sortType: (rowA, rowB) => {
                const dateTimeA = new Date(`${rowA.original.appointmentDate} ${rowA.original.appointmentTime || ''}`).getTime();
                const dateTimeB = new Date(`${rowB.original.appointmentDate} ${rowB.original.appointmentTime || ''}`).getTime();
                return dateTimeA - dateTimeB; // react-table will handle desc/asc
              }
            },
            {
                Header: 'Doctor',
                accessor: 'doctorName',
                Filter: () => null,
                Cell: ({ row }) => (
                <div>
                    <div> {row.original.doctorName || 'N/A'}</div>
                    <small className="text-muted">{row.original.doctorSpeciality || 'N/A'}</small>
                </div>
            )},
            {
                Header: 'Patient',
                accessor: 'patientName',
                Filter: () => null,
                Cell: ({ row }) => (
                 <div>
                    <div>{row.original.patientName || 'N/A'}</div>
                    <small className="text-muted">{row.original.patientPhone || 'N/A'}</small>
                </div>
            )},
            
            {
                Header: 'Fee (₹)',
                accessor: 'doctorFee',
                Filter: () => null,
                Cell: ({ value }) => value != null ? value.toFixed(2) : 'N/A'
            },
            {
                Header: 'Payment Status',
                accessor: 'paymentStatus',
                Filter: SelectColumnFilter,
                filter: 'equals',
                Cell: ({ value }) => (
                    <span className={`appoint-status-badge appoint-status-${value?.toLowerCase().replace(/_/g, '-')}`}>
                        {value?.replace(/_/g, ' ').toUpperCase() || 'N/A'}
                    </span>
            )},
            
            {
                Header: 'Appt. Status',
                accessor: 'status',
                Filter: SelectColumnFilter,
                filter: 'equals',
                Cell: ({ value }) => (
                    <span className={`appoint-status-badge appoint-status-${value?.toLowerCase().replace(/_/g, '-')}`}>
                        {value?.replace(/_/g, ' ').toUpperCase() || 'N/A'}
                    </span>
            )},
             {
               Header: 'Actions',
                id: 'actions',
                disableSortBy: true,
                Filter: () => null,
                Cell: ({ row }) => {
                    const appointment = row.original;
                    // === CHANGE 5 & 6B: UPDATE BUTTON TO BE A PRINT BUTTON ===
                    return (
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => handlePrintReceipt(appointment)}
                            disabled={isPrinting}
                            title="Print Receipt"
                        >
                            {isPrinting && receiptDataForPrint?._id === appointment._id ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                                <i className="fas fa-print"></i> // Print icon
                            )}
                        </button>
                    );
                }
            }
        ],
        [isPrinting, receiptDataForPrint]
    );
    const filteredData = useMemo(() => {
        if (dayFilter === 'today') {
            // Get today's date in the user's local timezone
            const today = new Date();
            const todayYear = today.getFullYear();
            const todayMonth = today.getMonth(); // 0-11
            const todayDate = today.getDate();

            return appointmentsData.filter(app => {
                // Important: Ensure the appointment date exists before processing
                if (!app.appointmentDate) {
                    return false;
                }

                // Create a Date object from the appointment date string.
                // This will also be interpreted in the user's local timezone.
                const appDate = new Date(app.appointmentDate);
                
                // Compare the year, month, and day parts
                return (
                    appDate.getFullYear() === todayYear &&
                    appDate.getMonth() === todayMonth &&
                    appDate.getDate() === todayDate
                );
            });
        }
        return appointmentsData;
    }, [appointmentsData, dayFilter]);
    
     const tableInstance = useTable(
        {
            columns,
            data: filteredData, // Use the pre-filtered data
           initialState: {
              pageIndex: 0,
              pageSize: 10,
              sortBy: [{ id: 'appointmentDateTime', desc: true }],
              // === CHANGE 3B: SET DEFAULT FILTER ON LOAD ===
              filters: [
                { id: 'status', value: 'confirmed' }
              ]
            },
            autoResetPage: true, // Allow page to reset on filter change
            autoResetSortBy: false,
            autoResetFilters: false,
            autoResetGlobalFilter: false,
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        rows,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize, globalFilter, sortBy, filters },
        setGlobalFilter,
        setFilter,
    } = tableInstance;

  // === CHANGE 4C: UPDATE FILTER BUTTON HANDLER ===
    const handleStatusButtonClick = (statusValue, filterColumnId = 'status') => {
        setActiveStatusFilter(statusValue);
        setDayFilter('all'); // Always reset day filter when a status is clicked
        setFilter(filterColumnId, statusValue === 'All' ? undefined : statusValue);
        gotoPage(0);
    };

      const handleTodayButtonClick = () => {
        setActiveStatusFilter(''); // Deselect other status buttons
        setDayFilter('today');
        // Clear other filters to not conflict
        setFilter('status', undefined);
        setFilter('paymentStatus', undefined);
        gotoPage(0);
    };

    const handleExportToExcel = () => {
        let dataToExport = tableInstance.rows.map(row => row.original);
        if (selectedDoctorForExport && selectedDoctorForExport !== 'All Doctors') {
            dataToExport = dataToExport.filter(item => item.doctorName === selectedDoctorForExport);
        }
        if (dataToExport.length === 0) {
            alert("No data to export based on current filters.");
            return;
        }
        const formattedData = dataToExport.map(app => ({
                 'Appt. ID': app.appointmentNumber || 'N/A', // Use new field
            
             'Appointment Date': app.appointmentDate ? new Date(app.appointmentDate).toLocaleDateString('en-GB') : 'N/A',
            'Appointment Time': app.appointmentTime || 'N/A',
            'Doctor Name': `${app.doctorName || 'N/A'}`,
            'Doctor Speciality': app.doctorSpeciality || 'N/A',
            'Patient Name': app.patientName || 'N/A',
            'Patient Phone': app.patientPhone || 'N/A',
            'Fee (₹)': app.doctorFee != null ? app.doctorFee.toFixed(2) : 'N/A',
            'Payment Status': app.paymentStatus?.replace(/_/g, ' ').toUpperCase() || 'N/A',
            'Appointment Status': app.status?.replace(/_/g, ' ').toUpperCase() || 'N/A',
            'Booked On': app.createdAt ? new Date(app.createdAt).toLocaleString('en-GB') : 'N/A', // Added new field
            'Booked At': app.createdAt ? new Date(app.createdAt).toLocaleString() : 'N/A'
        }));
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
        const colWidths = [
            { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 25 }, { wch: 20 },
            { wch: 20 }, { wch: 15 }, { wch: 10 }, { wch: 18 }, { wch: 18 }, { wch: 22 }
        ];
        worksheet['!cols'] = colWidths;
        let fileName = "appointments_export";
        if (selectedDoctorForExport && selectedDoctorForExport !== 'All Doctors') {
            fileName += `_${selectedDoctorForExport.replace(/\s+/g, '_')}`;
        }
        fileName += ".xlsx";
        XLSX.writeFile(workbook, fileName);
    };


    if (loading && appointmentsData.length === 0) {
        return (
            <div className="main-wrapper">
                <AdminSidebar />
                <div className="page-wrapper">
                    <div className="content container-fluid appoint-page-container text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mt-2">Fetching appointments...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!loading && error) {
        return (
           <div className="main-wrapper">
               <AdminSidebar />
               <div className="page-wrapper">
                   <div className="content container-fluid appoint-page-container">
                       <div className="alert alert-danger" role="alert">
                           Error: {error}
                       </div>
                   </div>
               </div>
           </div>
       );
   }

    return (
        <div className="main-wrapper">
            <AdminSidebar />
            <div className="page-wrapper">
                <div className="content container-fluid appoint-page-container">
                    <div className="page-header appoint-page-header">
                         <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title appoint-page-title">Appointments</h3>
                                <ul className="breadcrumb appoint-breadcrumb">
                                    <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                    <li className="breadcrumb-item active">Appointments</li>
                                </ul>
                            </div>
                             <div className="col-auto text-right float-right ml-auto">
                            </div>
                        </div>
                    </div>

                    <div className="card appoint-card shadow-sm">
                        <div className="card-header appoint-card-header">
                            <div className="row align-items-center">
                                <div className="col-md-4">
                                    <h4 className="card-title appoint-card-title mb-0">Appointment List</h4>
                                </div>
                                <div className="col-md-8 text-md-right">
                                    <div className="d-flex justify-content-md-end align-items-center">
                                        <select
                                            className="form-control form-control-sm appoint-doctor-filter-export mr-2"
                                            style={{maxWidth: '200px'}}
                                            value={selectedDoctorForExport}
                                            onChange={(e) => setSelectedDoctorForExport(e.target.value === 'All Doctors' ? '' : e.target.value)}
                                            disabled={loading || uniqueDoctorNames.length <= 1}
                                        >
                                            {uniqueDoctorNames.map(name => (
                                                <option key={name} value={name}>
                                                    {name}
                                                </option>
                                            ))}
                                        </select>
                                        <button
                                            className="btn btn-sm btn-success appoint-export-btn"
                                            onClick={handleExportToExcel}
                                            disabled={loading || tableInstance.rows.length === 0}
                                        >
                                            <i className="fas fa-file-excel mr-1"></i> Export to Excel
                                        </button>
                                    </div>
                                </div>
                            </div>
                             <div className="appoint-status-filters mt-2 d-flex flex-wrap justify-content-start">
                                <button
                                    className={`btn btn-sm mr-1 mb-1 ${activeStatusFilter === 'All' ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    onClick={() => handleStatusButtonClick('All', 'status')}
                                >
                                    All Status
                                </button>
                                <button
                                    className={`btn btn-sm mr-1 mb-1 ${activeStatusFilter === 'confirmed' ? 'btn-success' : 'btn-outline-success'}`}
                                    onClick={() => handleStatusButtonClick('confirmed', 'status')}
                                >
                                    Confirmed
                                </button>
                                <button
                                    className={`btn btn-sm mr-1 mb-1 ${activeStatusFilter === 'pending_payment' ? 'btn-warning' : 'btn-outline-warning'}`}
                                    onClick={() => handleStatusButtonClick('pending_payment', 'paymentStatus')}
                                >
                                    Pending Payment
                                </button>
                                <button
                                    className={`btn btn-sm mb-1 ${activeStatusFilter === 'failed' ? 'btn-danger' : 'btn-outline-danger'}`}
                                    onClick={() => handleStatusButtonClick('failed', 'status')}
                                >
                                    Failed/Cancelled
                                </button>
                                 <button
                                    className={`btn btn-sm mb-1 ml-auto ${dayFilter === 'today' ? 'btn-info' : 'btn-outline-info'}`}
                                    onClick={handleTodayButtonClick}
                                >
                                    <i className="fas fa-calendar-day mr-1"></i> Today's Appointments
                                </button>
                            </div>
                        </div>
                        <div className="card-body appoint-card-body">
                            <GlobalFilter globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
                            <div className="table-responsive appoint-table-responsive">
                                <table {...getTableProps()} className="table table-hover table-center table-striped appoint-table">
                                    <thead className="appoint-table-head">
                                        {headerGroups.map(headerGroup => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                                        {column.render('Header')}
                                                        <span>
                                                            {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                                                        </span>
                                                        <div>{column.canFilter ? column.render('Filter') : null}</div>
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>
                                    <tbody {...getTableBodyProps()} className="appoint-table-body">
                                        {page.map((row) => {
                                            prepareRow(row);
                                            return (
                                                <tr {...row.getRowProps()}>
                                                    {row.cells.map(cell => (
                                                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                        {page.length === 0 && (
                                            <tr>
                                                <td colSpan={columns.length} className="text-center appoint-no-data py-4">
                                                    {loading ? 'Fetching data...' : (globalFilter || (filters && filters.length > 0) ? 'No appointments match your current filters.' : 'No appointments found.')}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {appointmentsData.length > 0 && pageOptions.length > 1 && (
                                <div className="appoint-pagination-controls mt-3 d-flex flex-wrap justify-content-between align-items-center">
                                    <div className="mb-2 mb-md-0">
                                        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="btn btn-sm btn-outline-primary mr-1">
                                            {'<<'}
                                        </button>
                                        <button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-sm btn-outline-primary mr-1">
                                            {'<'}
                                        </button>
                                        <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-sm btn-outline-primary mr-1">
                                            {'>'}
                                        </button>
                                        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="btn btn-sm btn-outline-primary">
                                            {'>>'}
                                        </button>
                                    </div>
                                    <span className="mb-2 mb-md-0">
                                        Page{' '}
                                        <strong>
                                            {pageIndex + 1} of {pageOptions.length}
                                        </strong>
                                    </span>
                                    <div>
                                        <select
                                            className="form-control form-control-sm d-inline-block"
                                            style={{width: 'auto'}}
                                            value={pageSize}
                                            onChange={e => { setPageSize(Number(e.target.value)); }}
                                        >
                                            {[10, 20, 30, 50].map(size => (
                                                <option key={size} value={size}>Show {size}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
           <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                {receiptDataForPrint && (
                    <AppointmentReceipt ref={receiptComponentRef} data={receiptDataForPrint} />
                )}
            </div>
        </div>
    );
}

export default AppointmentList;